import { Controller, useFormContext } from "react-hook-form";
import { ITimePickerProps } from "./TimePickerProps";
import { FormControl, FormHelperText } from "@mui/material";
import { useMemo } from "react";
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import moment from "moment";
import { FnComponents, I18n } from "utilities/utilities";
import { I18NextNs, TypeComponent } from "enum/enum";

export const TimePickerItem = (props: ITimePickerProps) => {
  const {
    defaultValue = null,
    disabled = false,
    fullWidth,
    id,
    IsAMPM = false,
    IsShowMessageError = true,
    label,
    maxTime,
    minTime,
    name,
    required = false,
    size = "small"
  } = props;

  const { control } = useFormContext();

  const rules = useMemo(() => {
    let message = `${I18n.SetText("required", I18NextNs.validation)}`
    return {
      required: {
        value: required,
        message: message + `${label}`,
      },
    };
  }, [required, label]);

  return (
    <>
      <Controller
        key={"key" + name}
        name={name}
        control={control}
        rules={rules}
        shouldUnregister={true}
        defaultValue={defaultValue}
        render={({
          field: { onChange, value, ref },
          fieldState: { invalid, error },
        }) => {
          let isValid = invalid && !disabled;
        let helperText = IsShowMessageError
          ? `${I18n.SetText("required", I18NextNs.validation)} ${label}`
          : "";
          return (
            <>
             <LocalizationProvider
                  dateAdapter={AdapterMoment}
                  localeText={{
                    clearButtonLabel: I18n.SetText("DatePicker.Clear", I18NextNs.labelComponent),
                    okButtonLabel: I18n.SetText("DatePicker.Ok", I18NextNs.labelComponent),
                    cancelButtonLabel: I18n.SetText("DatePicker.Cancel", I18NextNs.labelComponent),
                  }}
                >
              <FormControl
                fullWidth={fullWidth}
              >
               
                  <TimePicker
                    inputRef={ref}
                    value={value}
                    slotProps={{
                      textField: {
                        id: FnComponents.GetId(TypeComponent.timePicker, id, name),
                        size: size,
                        error: invalid,
                        required: required,
                        autoComplete: "off",
                        sx: {
                          fontWeight: 600,
                        },
                      },
                      actionBar: {
                        actions: ["clear", "accept"],
                      },
                    }}
                    onChange={(event) => {
                      let IsValid = moment(event).isValid();
                      let dDate: Date = null;
                      if (IsValid) {
                        dDate = event;
                      }
                      onChange(dDate);
                      if (props.onChange) {
                        props.onChange(dDate);
                      }
                    }}
                    label={label}
                    ampm={IsAMPM}
                    disabled={disabled}
                    minTime={minTime}
                    maxTime={maxTime}
                  />
              </FormControl>
              </LocalizationProvider>
              {IsShowMessageError && isValid && (
              <FormHelperText>{helperText}</FormHelperText>
            )}
            </>
          );
        }}
      />
    </>
  );
};